import { render, staticRenderFns } from "./PriceGroupsBlock.vue?vue&type=template&id=9533d50c"
import script from "./PriceGroupsBlock.vue?vue&type=script&lang=js"
export * from "./PriceGroupsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports